<!--
 * @Date: 2022-07-08 09:29:42
 * @LastEditTime: 2022-07-21 19:15:36
 * @FilePath: /vue-medweb/packages/vue-m-vaccine-prefecture/src/components/StrategyCard/index.vue
 * @Description: 策略卡片
-->
<template>
  <div class="strategy-card-wrap" @click="jumpToDetail(strategy.jump_url)">
    <div class="title">{{ strategy.title }}</div>
    <div class="item-detail">
      <img
        class="icon"
        src="https://staff.chunyu.mobi/@/media/images/2022/07/04/398c/ca704e3e21f1_w54_h54_.png"
        alt=""
      />
      <div class="desc">{{ strategy.desc }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'StrategyCard',
  props: {
    strategy: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('publicStore', {
      app: 'app',
    }),
  },
  methods: {
    /**
     * @description 点击疫苗攻略
     * @param {string} jump_url 跳转的url
     */
    jumpToDetail(jump_url) {
      window.location.href = `${jump_url}?#OPEN_NEW_WIN`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';

.strategy-card-wrap {
  width: 100%;
  height: rem(74);
  padding: rem(15);
  background: #f3f6fb;
  border-radius: rem(4);
  .title {
    font-weight: bold;
    font-size: rem(16);
  }
  .item-detail {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: rem(18);
    margin: rem(9) 0 rem(18);
    overflow: hidden;
    .icon {
      flex-basis: rem(18);
      flex-shrink: 0;
      height: rem(18);
      margin-right: rem(8);
    }
    .desc {
      padding-top: rem(2);
      line-height: rem(18);
      @include multiple-ellipsis(1);
    }
  }
}
</style>
